// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"BrandFooter_footerWrapper__kTvNx","footerContainer":"BrandFooter_footerContainer__PcSZv"};